class INTENT.utils.Url

  # transform query string into object
  @asObject: =>
    _.object _.compact _.map location.search[1..].split('&'), (item) -> if item then item.split '='

  # checks for parameter presence in query string
  @hasParam: (param) =>
    param of @getAsObject()

  # Simple getter for param in query string
  @getParam: (param, _default=null) =>
    get = @getAsObject()
    if param of get then get[param] else _default

  # compiles {}'s to url encoded query strings
  @asString: (queryObject = {}) =>
    url = []
    _.each queryObject, (v, k) ->
      url.push _.map([k,v], encodeURIComponent).join '='
    "?#{url.join '&'}"




